import React, {Component} from 'react';
import {combineLatest, Subject} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import {Header, Subheader, Logo} from '../form/static';
import {LoginFooter} from './footer';
import {Input} from '../form/inputs';
import {Wrapper as ButtonsWrapper} from '../form/buttons/wrapper';
import {Button} from '../form/buttons/button';
import {FormError} from 'app/model/FormError';
import {Translate} from 'app/services/translate';
import {socialLoginAvailability} from '../social.resolver';
import {AuthService} from 'app/components/sign/auth.service';
import {validateNullability, validateUsername} from '../form/validator';
import {SocialLogin} from '../form/social/social';
import {Error} from 'app/components/sign/form/static/error';

export class Login extends Component {
    constructor(props) {
        super(props);

        this.auth = new AuthService();

        this.state = {
            username: null,
            password: null,
            errors: [],
            loading: true,
        };

        this.username$ = new Subject();
        this.pass$ = new Subject();

        this.usernameErrors$ = new Subject();
        this.passwordErrors$ = new Subject();
        this.otherErrors$ = (new Subject()).pipe(map((errors) => errors.map(FormError.mapToThis)));

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        socialLoginAvailability()
            .then((response) => this.setState({
                loading: false,
                socialLoginAvailable: response,
            }));

        combineLatest([this.username$.pipe(startWith(null)), this.pass$.pipe(startWith(null))])
            .pipe(map(([username, password]) => ({username, password})))
            .subscribe(this.setState.bind(this));

        this.username$.subscribe((username) => this.usernameErrors$.next(validateUsername(username)));
        this.pass$.subscribe((password) => this.passwordErrors$.next(validateNullability(password, 'password')));
        this.otherErrors$.subscribe((errors) => this.setState({errors}));
    }

    handleSubmit(evt) {
        evt.preventDefault();

        const {username, password} = this.state;
        this.auth.signIn({username, password})
            .then(() => this.setState({errors: []}))
            .catch((err) => this.otherErrors$.next(err.response.data.errors));
    }

    render() {
        return !this.state.loading ? (
            <div className="form-wrapper">
                <div className="form-container">
                    <form onSubmit={this.handleSubmit} role="form">
                        <Logo/>
                        <Header>{Translate('signing_login_header')}</Header>
                        <Subheader>{Translate('signing_login_subheader')}</Subheader>

                        {this.state.errors.length > 0 && (
                            <div className="mt-3 text-center">
                                <Error errors={this.state.errors}/>
                            </div>
                        )}

                        <Input
                            label={Translate('signing_login_login')}
                            type="text"
                            errors$={this.usernameErrors$}
                            handleChange$={this.username$}/>
                        <Input
                            label={Translate('signing_login_password')}
                            type="password"
                            errors$={this.passwordErrors$}
                            handleChange$={this.pass$}/>

                        <a className="remind-link" href={Translate('signing_remind_url')}>
                            {Translate('signing_login_remind_incentive')}
                        </a>

                        <ButtonsWrapper>
                            <Button type="submit">{Translate('signing_login_login_button')}</Button>
                        </ButtonsWrapper>

                        {this.state.socialLoginAvailable && (
                            <SocialLogin
                                formType="login"
                                errors$={this.otherErrors$}
                                dividerText={Translate('signing_login_divider')}/>
                        )}

                        <LoginFooter/>
                    </form>
                </div>
            </div>
        ) : <div className="sk-circle"/>;
    }
}
